import {Component} from '@angular/core';
import {GenericChartComponent} from "../generic-chart/generic-chart.component";
import {FinanceDashboardChartType} from "../../enum/FinanceDashboardChartType";
import {TravelTypePieChartColorOptionsArray} from "../../constants/finance-dashboard-chart-options";

@Component({
  selector: 'app-insight-requests',
  templateUrl: './insight-requests.component.html',
  standalone: false,
})
export class InsightRequestsComponent extends GenericChartComponent {
  constructor() {
    super();
    this.chartConfiguration = {
      title: 'App insight requests',
      chartType: FinanceDashboardChartType.Pie,
      backGroundColor: TravelTypePieChartColorOptionsArray,
      borderColor: TravelTypePieChartColorOptionsArray,
    };
  }

}
